module.exports = __webpack_public_path__ + "static/media/pytorch.d383c738.svg";